import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { selectionProcessesAdmin } from '@/services/selectionProcesses';
import { Dashboard, DashboardContent } from '@/layouts/dashboard';
import SelectionProcessSidebar from './Sidebar';
import SelectionProcessContent from './Content';

const STEPS = [
  { id: 1, route: 'identificacao', text: 'Defina o nome e a descrição do processo seletivo.' },
  { id: 2, route: 'periodo', text: 'Defina o período de inscrições.' },
  { id: 3, route: 'perguntas', text: 'Adicione perguntas extras ao formulário público.' },
  { id: 4, route: 'revisao', text: 'Revise e publique o processo seletivo.' }
];

const empty = {
  name: '',
  description: '',
  starts_at: '',
  ends_at: '',
  regional_id: '',
  target_audience: 'student',
  collect_education_info: true,
  collect_work_info: true
};

export default function SelectionProcessFormPage() {
  const { id } = useParams();
  const [currentStep, setCurrentStep] = useState(1);
  const [initialValues, setInitialValues] = useState(empty);
  const [loadingInitial, setLoadingInitial] = useState(false);

  useEffect(() => {
    if (!id) return;
    setLoadingInitial(true);
    selectionProcessesAdmin
      .get(id)
      .then(res => {
        const a = res.data.attributes;
        setInitialValues({
          name: a.name || '',
          description: a.description || '',
          starts_at: a.starts_at ? a.starts_at.slice(0, 16) : '',
          ends_at: a.ends_at ? a.ends_at.slice(0, 16) : '',
          regional_id: a.regional_id || '',
          target_audience: a.target_audience || 'student',
          editable_target_audience: a.editable_target_audience !== false,
          collect_education_info: a.collect_education_info !== false,
          collect_work_info: a.collect_work_info !== false
        });
      })
      .catch(() => {})
      .finally(() => setLoadingInitial(false));
  }, [id]);

  return (
    <Dashboard>
      <SelectionProcessSidebar
        steps={STEPS}
        currentStep={currentStep}
      />

      <DashboardContent viewMode="create">
        <SelectionProcessContent
          id={id}
          currentStep={currentStep}
          setCurrentStep={setCurrentStep}
          initialValues={initialValues}
          loadingInitial={loadingInitial}
        />
      </DashboardContent>
    </Dashboard>
  );
}
